module.exports = __webpack_public_path__ + "static/media/map-anchor.6651fe59.png";